import request from '@/utils/request'; // 列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/convenientMaintenance/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/convenientMaintenance/insert',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/convenientMaintenance/update',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/convenientMaintenance/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/convenientMaintenance/delete',
    method: 'post',
    data: data
  });
}